import validateInputDOB from '../validateInputDOB';

export default dob => !dob || validateInputDOB(dob);



// WEBPACK FOOTER //
// ./src/utils/validations/DOBValidator.js